module fdm {
    //Global Route Configuration
    angular.module('fdm').config(($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider,
        $httpProvider: ng.IHttpProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider, $provide) => {

        $stateProvider
            .state('app', {
                url: '/',
                template: '<app-layout/>'
                //templateUrl: '/src/layout/app-layout.html',
            })
            .state('signin', {
                url: '/signin',
                templateUrl: '/app/src/layout/signin.html',
                controller: 'SigninController'
            })
            .state('404', {
                url: '*path',
                template: '<error-handler />',
                params: {
                    errorCode: '404'
                }
            })
            .state('error-handler', {
                template: '<error-handler />',
                params: {
                    errorCode: null
                }
            })
            .state('no-connection', {
                template: '<no-connection-handler />'
            })

        dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
            .commandState('defaultCommand')
            .exportState('defaultExport')
            .modalListState('tasksStatusList', 'command-envelope/tasks-status', {
                options: ($transition$: any, $stateParams: any) => <dg.actions.IQueryInvokerOptions>{
                    isModal: true,
                    hideActions: true,
                    compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                        <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                            actionColumnEnabled: true,
                            uiGrid: {
                                columnDefs: [
                                    { field: 'updatedOn', width: 110 }
                                ]
                            }
                        })
                    ]

                }
            }, {
                windowClass: 'extra-wide-modal'
            })
            .modalListState('flightTraceNamedSetList', 'named-set/list', {
                options: ($transition$: any, $stateParams: any) => <dg.actions.IQueryInvokerOptions>{
                    isModal: true,
                    hideActions: true,
                    compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                        <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                            actionColumnEnabled: true,
                            selectionType: 'single'
                        })
                    ]
                }
            }, {
                windowClass: 'extra-wide-modal'
            });


        //Required base tag is disabled because it causes problems with SVG elements, Issue https://github.com/angular/angular.js/issues/8934
        $locationProvider.html5Mode({ enabled: true, requireBase: false }).hashPrefix('!');

        //$urlRouterProvider.when('/', '/dashboard');


        //.state('app.reports', {
        //    url: 'reports',
        //    templateUrl: '/reports',
        //    data: {
        //        allowAnonymous : true
        //    }
        //})


    })
}